import { render, staticRenderFns } from "./add.vue?vue&type=template&id=73f5cf0a&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5cf0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f5cf0a')) {
      api.createRecord('73f5cf0a', component.options)
    } else {
      api.reload('73f5cf0a', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=73f5cf0a&scoped=true", function () {
      api.rerender('73f5cf0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permission/add.vue"
export default component.exports